import { render, staticRenderFns } from "./ProductsStock.vue?vue&type=template&id=7b2799dc&"
import script from "./ProductsStock.vue?vue&type=script&lang=js&"
export * from "./ProductsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports